document.addEventListener("DOMContentLoaded", function () {

    let currentIndex = 0;
    const slides = document.querySelectorAll(".fldmainbanneropt-slide");
    const totalSlides = slides.length;
    const sliderWrapper = document.querySelector(".fldmainbanneropt-slider-wrapper");

    let isAnimating = false;

    function updateSlider() {

        if (isAnimating) return;

        isAnimating = true;

        sliderWrapper.style.transition = "transform .5s ease";
        sliderWrapper.style.transform =
            `translateX(-${currentIndex * 100}%)`;

        setTimeout(function () {
            isAnimating = false;
        }, 500);

    }

    function nextSlide() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
    }

    window.moveSlide = function(direction){

        if(isAnimating) return;

        currentIndex += direction;

        if(currentIndex < 0){
            currentIndex = totalSlides-1;
        }

        if(currentIndex >= totalSlides){
            currentIndex = 0;
        }

        updateSlider();

    }

    setInterval(nextSlide,4500);

});



// Function to create floting trusting badge starts here

window.addEventListener('scroll', function() {
  var floatingImage = document.querySelector('.floating-image');
  
  if (window.scrollY > 200) {  // Show after 200px scroll
    floatingImage.style.opacity = '1';
  } else {
    floatingImage.style.opacity = '0';
  }
});



// Function to create floting trusting badge ends here



